module.exports = __webpack_public_path__ + "static/media/22712488_1629543533787498_7172028488074006799_o.6f2443ef.jpg";